/**
 * Add 'is-stuck' class when element reaches specified offset from top
 */

export default (() => {
  const element = document.querySelector('[data-sticky-element]')

  if (!element) return

  const elementClass = element.classList
  const offset = parseInt(element.getAttribute('data-sticky-offset') || '0', 10)

  const checkStickiness = () => {
    const rect = element.getBoundingClientRect()

    if (rect.top <= offset) {
      elementClass.add('is-stuck')
    } else {
      elementClass.remove('is-stuck')
    }
  }

  // Check on load and scroll
  window.addEventListener('load', checkStickiness)
  window.addEventListener('scroll', checkStickiness)
})()
